import { render, staticRenderFns } from "./CheckoutWizardStepShipment.vue?vue&type=template&id=791c4106&scoped=true"
import script from "./CheckoutWizardStepShipment.vue?vue&type=script&lang=ts"
export * from "./CheckoutWizardStepShipment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c4106",
  null
  
)

export default component.exports